import { DEFINITIONS as ORDERED_LIST_DEFINITIONS } from '@xingternal/content-editor-plugin-ordered-list';

import { DEFINITIONS as UNORDERED_LIST_DEFINITIONS } from '@xingternal/content-editor-plugin-unordered-list';

import { SERIALIZATION, DESERIALIZATION } from './constants';
import { serializationHelpers, deserializationHelpers } from './helpers';
// eslint-disable-next-line max-len
// eslint-disable-next-line max-len

const checkType = (serializerFn) => {
  if (typeof serializerFn !== 'function') {
    throw new Error(`invalid serializer: '${serializerFn}' is not a function`);
  }
};

class Serializer {
  nodeSerializers = [];
  markSerializers = [];
  direction = null;

  constructor({ nodeSerializers = [], markSerializers = [] }) {
    nodeSerializers.every(checkType);
    this.nodeSerializers = nodeSerializers;

    markSerializers.every(checkType);
    this.markSerializers = markSerializers;
  }

  serialize(nodes) {
    return this.withDirection(SERIALIZATION, () => this.processNodes(nodes));
  }

  deserialize(nodes) {
    return this.withDirection(DESERIALIZATION, () => this.processNodes(nodes));
  }

  withDirection(direction, callback) {
    this.direction = direction;
    const result = callback();
    this.direction = null;
    return result;
  }

  flattenListsBeforeSerialization = (nodes) => {
    let newNodes = [...nodes]; // can't change original nodes (read-only)
    for (let i = 0; i < newNodes.length; i++) {
      if (
        newNodes[i] &&
        newNodes[i].type &&
        (newNodes[i].type === ORDERED_LIST_DEFINITIONS.type ||
          newNodes[i].type === UNORDERED_LIST_DEFINITIONS.type)
      ) {
        // flag list types
        let inlineNodes = newNodes[i].children.map((listItem) =>
          Object.assign({}, listItem, { listType: newNodes[i].type })
        );
        // replace list with it's list-items children
        newNodes.splice(i, 1, ...inlineNodes);
      }
    }
    return newNodes;
  };

  concatenateListsAfterDeserialization = (nodes) => {
    if (nodes.length > 1) {
      let currentNodeIndex = 1;
      while (currentNodeIndex < nodes.length) {
        // if this node is a list of the same type of previous node
        if (
          (nodes[currentNodeIndex].type === ORDERED_LIST_DEFINITIONS.type &&
            nodes[currentNodeIndex - 1].type ===
              ORDERED_LIST_DEFINITIONS.type) ||
          (nodes[currentNodeIndex].type === UNORDERED_LIST_DEFINITIONS.type &&
            nodes[currentNodeIndex - 1].type ===
              UNORDERED_LIST_DEFINITIONS.type)
        ) {
          // put this node childrens into previous node, then delete this node.
          nodes[currentNodeIndex - 1].children = nodes[
            currentNodeIndex - 1
          ].children.concat(nodes[currentNodeIndex].children);
          nodes.splice(currentNodeIndex, 1);
        } else {
          // if is not what we want, move cursor forward
          currentNodeIndex++;
        }
      }
    }
    return nodes;
  };

  processNodes = (nodes = []) => {
    if (this.direction === SERIALIZATION) {
      // flag list-items with their list type on them and bring them to the same level
      nodes = this.flattenListsBeforeSerialization(nodes);
    }

    let nodesToReturn = nodes
      .filter((value) => value !== null)
      .map((node) => this.processNode(node))
      .filter((value) => value !== undefined);

    if (this.direction === DESERIALIZATION) {
      // join adjacent lists of the same type
      nodesToReturn = this.concatenateListsAfterDeserialization(nodesToReturn);
    }

    return nodesToReturn;
  };

  processNode = (node) => {
    let val;

    this.nodeSerializers.find(
      (serializer) =>
        (val = serializer({
          node,
          direction: this.direction,
          serializeNodes: this.processNodes,
          serializeNode: this.processNode,
          serializeMark: this.processText,
          ...(this.direction === SERIALIZATION
            ? serializationHelpers
            : deserializationHelpers),
        }))
    );
    return val;
  };

  processText = (nodes) =>
    nodes
      .map((node) => {
        let val;
        this.markSerializers.find(
          (serializer) =>
            (val = serializer({
              node,
              direction: this.direction,
              ...(this.direction === SERIALIZATION
                ? serializationHelpers
                : deserializationHelpers),
            }))
        );
        return val;
      })
      .filter((n) => !!n);
}

export { Serializer, SERIALIZATION, DESERIALIZATION };
